import React, { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { Sparkles, Lock } from "lucide-react";
import SubscribeDialog from "@/components/SubscribeDialog";

export default function TrialBanner() {
  const { user, subscriptionStatus, trialDaysRemaining } = useAuth();
  const [openSub, setOpenSub] = useState(false);

  if (!user) return null;
  // Admin and active subscribers don't need the banner.
  if (subscriptionStatus === "admin" || subscriptionStatus === "active") return null;

  const expired = subscriptionStatus === "expired";
  const days = trialDaysRemaining ?? 0;

  return (
    <>
      <div
        className={`rounded-xl px-5 py-4 mb-8 flex flex-col sm:flex-row sm:items-center gap-4 justify-between fade-up ${
          expired
            ? "bg-gradient-to-r from-[#1E1B4B] via-[#312E81] to-[#0B1437] text-white"
            : "bg-gradient-to-r from-[#0052FF] via-[#1E40AF] to-[#0B1437] text-white"
        }`}
        data-testid="trial-banner"
      >
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-white/10 flex items-center justify-center">
            {expired ? (
              <Lock className="w-5 h-5 text-[#FBBF24]" />
            ) : (
              <Sparkles className="w-5 h-5 text-[#00E590]" />
            )}
          </div>
          <div>
            <p className="text-sm font-display font-semibold tracking-tight">
              {expired
                ? "Tu prueba ha terminado"
                : days === 1
                ? "Último día de prueba"
                : `Te quedan ${days} días de prueba`}
            </p>
            <p className="text-xs text-white/70 mt-0.5">
              {expired
                ? "Suscríbete para desbloquear proyección, dinero por día y recomendaciones."
                : "Disfruta acceso completo a Finly+ Premium durante tu prueba."}
            </p>
          </div>
        </div>
        <button
          onClick={() => setOpenSub(true)}
          className="bg-[#00E590] hover:bg-[#00C97D] text-[#0B1437] font-semibold text-sm px-5 py-2.5 rounded-lg transition-colors"
          data-testid="trial-banner-subscribe-btn"
        >
          {expired ? "Suscribirme" : "Mejorar a Premium"}
        </button>
      </div>

      <SubscribeDialog open={openSub} onOpenChange={setOpenSub} />
    </>
  );
}
